const RELOAD_KEY = "reloadOnNewVersionAt";
const MIN_DELAY_BETWEEN_RELOADS = 10_000;

let isReloading = false;

export const isReloadingOnNewVersion = () => isReloading;

const canReload = () => {
  try {
    const lastReload = Number(sessionStorage.getItem(RELOAD_KEY));
    if (Date.now() - lastReload < MIN_DELAY_BETWEEN_RELOADS) {
      return false;
    }
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    return true;
  } catch {
    // No storage to guard against a reload loop
    return false;
  }
};

/**
 * Lazy chunks of the previous version are removed on deploy: reload the page once to get the new version.
 * If the chunk is still missing after the reload, the error goes through as usual (Oops page + Sentry).
 */
export const reloadOnNewVersion = () => {
  window.addEventListener("vite:preloadError", (event) => {
    if (canReload()) {
      event.preventDefault();
      isReloading = true;
      window.location.reload();
    }
  });
};
